<template>
  <div class="line-item-v2">
    <div class="d-flex mb-3 align-items-center justify-space-between flex-wrap">
      <div class="d-flex align-items-center">
        <v-autocomplete
          v-if="relatedType != 7 && !isOpportunity"
          hide-details
          v-model.trim="module_type_top"
          :items="modulesTypeComputed"
          clearable
          v-on:click:clear="module_type_top = null"
          style="max-width: 220px !important"
          dense
          flat
          filled
          placeholder="Select item type"
          item-color="cyan"
          class="mr-2 custom-boder-color"
          color="cyan"
          solo
          :menu-props="{ offsetY: true }"
          v-on:change="open_dialog($event, 'top')"
          item-value="value"
          item-text="text"
        >
        </v-autocomplete>
        <v-autocomplete
          v-if="isOpportunity"
          hide-details
          v-model.trim="module_type_top"
          :items="modulesType2"
          clearable
          v-on:click:clear="module_type_top = null"
          style="max-width: 220px !important"
          dense
          flat
          filled
          placeholder="Select item type"
          item-color="cyan"
          class="mr-2 custom-boder-color"
          color="cyan"
          solo
          :menu-props="{ offsetY: true }"
          v-on:change="open_dialog($event, 'top')"
          item-value="value"
          item-text="text"
        >
        </v-autocomplete>
        <v-btn-toggle color="cyan" group class="rounded-lg">
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="product"
            v-on:click="open_dialog('product')"
            v-if="relatedType != 7 && false"
          >
            Product
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="service"
            v-on:click="open_dialog('service')"
            v-if="relatedType != 7 && false"
          >
            Service
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="equipment"
            v-if="relatedType == 7"
            v-on:click="open_dialog('equipment')"
          >
            Equipment
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="tools"
            v-on:click="open_dialog('tools')"
            v-if="relatedType != 7 && false"
          >
            Equipment/Tools
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="header"
            v-on:click="add_header()"
            style="height: 32px !important"
          >
            Header
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="other"
            v-on:click="add_other()"
            style="height: 32px !important"
            v-if="relatedType != 7"
          >
            <v-icon small class="mr-1">mdi-plus</v-icon>
            Other
          </v-btn>
        </v-btn-toggle>
        <v-checkbox
          v-model="is_lump_sum"
          color="cyan"
          label="Is Lump Sum"
          v-on:change="emit_values()"
          dense
          hide-details
          class="ml-3 my-0"
          v-if="isQuotationModule"
        />
      </div>
      <div class="d-flex align-items-center">
        <v-checkbox
          v-if="
            !isEnquiry && !isQuotation && !isPreventive && !isProject && false
          "
          class="my-0 py-0 mr-3"
          v-model="show_price"
          v-on:change="emit_values()"
          color="cyan"
          hide-details
          label="Show Price To Engineer"
        />
        <div class="d-flex align-items-center ml-2 pl-3 custom-border-left">
          <label
            for="discount-level"
            class="mb-0 font-weight-600 font-size-13 color-custom-blue mr-2 text-nowrap"
            >Discount Level</label
          >
          <v-autocomplete
            :menu-props="{ offsetY: true }"
            :disabled="relatedDetail && relatedDetail.id > 0"
            hide-details
            v-model.trim="discount_level"
            :items="transactions"
            style="max-width: 180px !important"
            dense
            flat
            filled
            placeholder="Discount Level"
            item-color="cyan"
            class="custom-boder-color"
            color="cyan"
            solo
            v-on:change="calculate_total()"
            item-value="value"
            item-text="text"
          >
          </v-autocomplete>
        </div>
      </div>
    </div>

    <v-card
      flat
      outlined
      class="rounded-lg border-slate bg-white overflow-hidden mb-4 shadow-0"
    >
      <div
        class="d-flex grey lighten-4 border-bottom align-items-center px-3 py-2"
      >
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase text-center d-flex align-items-center justify-center"
          style="width: 4%"
        >
          #
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase text-left px-2 d-flex align-items-center"
          :style="{
            width: isPurchaseOrder
              ? discount_level == 'line_item'
                ? '24%'
                : '32%'
              : discount_level == 'line_item'
              ? '43%'
              : '56%',
          }"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-package-variant-closed</v-icon
          >
          <template v-if="relatedType == 7">Equipment</template>
          <template v-else
            >Product / Service
            <span v-if="!isPurchaseOrder">/ Equipment</span></template
          >
        </div>
        <div
          v-if="isPurchaseOrder"
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-1 d-flex align-items-center justify-center text-center"
          style="width: 8%"
        >
          Type
        </div>
        <div
          v-if="isPurchaseOrder"
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-1 d-flex align-items-center justify-center text-center"
          style="width: 11%"
        >
          Linked Quotation
        </div>
        <div
          v-if="isPurchaseOrder"
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-1 d-flex align-items-center justify-center text-center"
          style="width: 11%"
        >
          Allocation
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-1 d-flex align-items-center justify-center text-center"
          :style="{ width: isPurchaseOrder ? '10%' : '12%' }"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-tag-outline</v-icon
          >
          Selling/Unit Cost
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-2 d-flex align-items-center justify-center text-center"
          :style="{ width: isPurchaseOrder ? '7%' : '8%' }"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-ruler-square</v-icon
          >
          UOM
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-2 d-flex align-items-center justify-center text-center"
          :style="{ width: isPurchaseOrder ? '7%' : '8%' }"
        >
          <v-icon small color="cyan darken-2" class="mr-1">mdi-numeric</v-icon>
          Quantity
        </div>
        <div
          v-if="discount_level == 'line_item'"
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-2 d-flex align-items-center justify-center text-center"
          :style="{ width: isPurchaseOrder ? '10%' : '13%' }"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-percent-outline</v-icon
          >
          Discount
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-2 d-flex align-items-center justify-center text-center"
          :style="{ width: isPurchaseOrder ? '6%' : '8%' }"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-cash-multiple</v-icon
          >
          Total
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase text-center"
          style="width: 4%"
        ></div>
      </div>
      <Draggable
        tag="ul"
        v-model="selected_line_items"
        class="line-item-drag-group mb-0 pa-0"
        draggable=".line-item-drag"
        handle=".line-item-drag-icon"
        ghost-class="line-item-ghost"
        :key="`line-item-img-${dialog_key}`"
        animation="200"
        group="line-item-drag"
        v-on:start="drag = true"
        v-on:end="drag = false"
        v-on:change="emit_values()"
      >
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <li
            v-for="(row, index) in selected_line_items"
            class="line-item-drag border-bottom border-slate-100 hover:bg-slate-50 transition-fast pa-0"
            :class="{
              'alternate-line-item-row bg-slate-50':
                selected_line_items[index + 1]?.is_child,
            }"
            :key="`line-item-drag-${index}`"
          >
            <div
              :id="`line-item-drag-${index}`"
              class="d-flex align-items-top py-2 px-3"
              :class="{ 'item-is-child pl-4': row.is_child }"
            >
              <div class="font-weight-600 text-center" style="width: 4%">
                <v-icon
                  v-if="!row.is_child"
                  class="line-item-drag-icon cursor-move text-slate-400 hover-cyan"
                  >mdi-drag</v-icon
                >
              </div>
              <div
                v-if="row.is_child"
                class="font-weight-600 text-center"
                style="width: 4%"
              >
                <v-icon
                  class="line-item-drag-icon cursor-move text-slate-400 hover-cyan"
                  >mdi-drag</v-icon
                >
              </div>
              <div
                v-if="row.type === 'header'"
                class="text-left px-2 d-flex align-items-center"
                style="width: 100%"
              >
                <v-text-field
                  v-model="row.product"
                  class="line-item-header-text px-0"
                  placeholder="Header Title"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  v-on:change="changeName(index, row.product)"
                  color="cyan"
                >
                  <template v-slot:append>
                    <v-chip
                      color="cyan white--text"
                      label
                      small
                      class="lip-type text-uppercase font-weight-600 header"
                    >
                      Header
                    </v-chip>
                  </template>
                </v-text-field>
              </div>
              <div
                v-else
                class="text-left px-2"
                :style="{
                  width: isPurchaseOrder
                    ? discount_level == 'line_item'
                      ? row.is_child
                        ? '19%'
                        : '24%'
                      : row.is_child
                      ? '27%'
                      : '32%'
                    : discount_level == 'line_item'
                    ? row.is_child
                      ? '38%'
                      : '43%'
                    : row.is_child
                    ? '51%'
                    : '56%',
                }"
              >
                <div class="d-flex align-items-top">
                  <v-avatar
                    size="32"
                    v-if="row.product_type != 'other'"
                    class="rounded-lg border"
                  >
                    <img
                      v-if="row?.image?.url"
                      :src="row?.image?.url"
                      :alt="row?.image?.name"
                    />
                    <img v-else :src="$defaultImage" />
                  </v-avatar>
                  <div style="width: 100%" class="ml-2">
                    <v-expansion-panels class="cepfli flat">
                      <v-expansion-panel class="bg-transparent">
                        <v-expansion-panel-header class="pa-0 min-height-unset">
                          <v-text-field
                            v-model="row.product"
                            class="line-item-header-text px-0"
                            placeholder="Product/Service/Equipment & Tools"
                            dense
                            filled
                            solo
                            v-on:change="changeName(index, row.product)"
                            flat
                            hide-details
                            color="cyan"
                          >
                            <template v-slot:append>
                              <v-chip
                                color="cyan white--text"
                                label
                                small
                                class="lip-type text-uppercase font-weight-600"
                                :class="{
                                  product: row.product_type == 'goods',
                                  service: row.product_type == 'service',
                                  parts: row.product_type == 'parts',
                                  equipment: row.product_type == 'equipment',
                                  tools: row.product_type == 'tools',
                                  other: row.product_type == 'other',
                                }"
                              >
                                <template v-if="row.type == 'tools'">
                                  Tools</template
                                >
                                <template v-else-if="row.type == 'equipment'">
                                  Equipment</template
                                >
                                <template v-else> {{ row.type }}</template>
                              </v-chip>
                              <template
                                v-if="
                                  row.product_type == 'goods' ||
                                  row.product_type == 'parts' ||
                                  row.type == 'product' ||
                                  row.type == 'parts'
                                "
                              >
                                <template
                                  v-if="
                                    isJob &&
                                    (row?.isSerialized > 0 ||
                                      row?.serial_number == 1)
                                  "
                                >
                                  <v-tooltip
                                    top
                                    content-class="custom-top-tooltip"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-chip
                                        v-bind="attrs"
                                        v-on="on"
                                        :color="getSerialTagColor(row)"
                                        label
                                        small
                                        v-on:click.stop="
                                          optionSerial(row, index)
                                        "
                                        class="text-uppercase font-weight-600 white--text cursor-pointer ml-1"
                                      >
                                        <v-icon x-small class="mr-1"
                                          >mdi-pound</v-icon
                                        >
                                        {{ getSerialCount(row) }} /
                                        {{ row.quantity || 0 }} Serials
                                      </v-chip>
                                    </template>
                                    <span class="text-uppercase">
                                      {{ getSerialTooltipText(row) }}
                                    </span>
                                  </v-tooltip>

                                  <v-tooltip
                                    top
                                    content-class="custom-top-tooltip"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-chip
                                        v-bind="attrs"
                                        v-on="on"
                                        color="cyan darken-2"
                                        label
                                        small
                                        style="margin-left: 5px"
                                        v-on:click.stop="
                                          optionSerial(row, index)
                                        "
                                        class="text-uppercase font-weight-600 white--text cursor-pointer"
                                      >
                                        <v-icon small>mdi-cog</v-icon>
                                      </v-chip>
                                    </template>
                                    <span>Manage Serial Numbers</span>
                                  </v-tooltip>
                                </template>
                              </template>
                            </template>
                          </v-text-field>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="px-0 pt-2">
                          <v-textarea
                            class="px-0 mb-0"
                            v-model="row.description"
                            placeholder="Description"
                            dense
                            filled
                            solo
                            flat
                            rows="2"
                            auto-grow
                            hide-details
                            color="cyan"
                            v-on:change="changeDes(index, row.description)"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <div class="d-flex align-items-center flex-wrap ml-0 mt-1">
                      <v-chip
                        v-if="row.barcode"
                        label
                        color="cyan darken-3"
                        outlined
                        x-small
                        class="font-weight-700 mr-2"
                        v-on:click="routeToDetail(row)"
                        >{{ row.barcode }}</v-chip
                      >
                      <v-checkbox
                        v-if="row.type == 'product' && !isPurchaseOrder"
                        color="cyan"
                        label="Add as equipment"
                        dense
                        class="pt-0 mt-0 ml-2 mr-2"
                        v-model="row.is_equipment"
                        hide-details
                        :false-value="0"
                        :true-value="1"
                        v-on:change="changeEquipment(index, row.is_equipment)"
                      >
                      </v-checkbox>
                      <template
                        v-if="
                          row.product_type == 'goods' ||
                          row.product_type == 'parts' ||
                          row.type == 'product' ||
                          row.type == 'parts'
                        "
                      >
                        <v-chip
                          :color="
                            row?.isSerialized
                              ? 'green darken-1'
                              : 'red lighten-1'
                          "
                          class="font-weight-600 mr-2"
                          x-small
                          label
                          text-color="white"
                        >
                          {{
                            row?.isSerialized ? "Serialized" : "Non-serialized"
                          }}
                        </v-chip>
                      </template>
                      <template
                        v-if="
                          row.product_type != 'goods' &&
                          row &&
                          row.has_warranty &&
                          row.has_warranty == 1 &&
                          row.warranty_status > 0
                        "
                      >
                        <v-chip
                          :color="getWarrantyStatusColor(row.warranty_status)"
                          x-small
                          text-color="white"
                          class="font-weight-600 mr-2"
                        >
                          Warranty
                        </v-chip>
                      </template>
                      <template
                        v-if="
                          row.product_type == 'equipment' &&
                          row &&
                          row.preventive_id &&
                          row.preventive_barcode &&
                          row.preventive_id > 0 &&
                          showModules.preventive_maintanance
                        "
                      >
                        <v-chip
                          :color="row?.is_consumed ? 'red' : 'cyan darken-2'"
                          class="mr-2 font-weight-600"
                          x-small
                          outlined
                          v-on:click.prevent.stop="
                            routeToDetailLink(
                              row.preventive_id,
                              'admin.preventive-maintanance.detail'
                            )
                          "
                        >
                          {{ row.preventive_barcode }}
                        </v-chip>
                      </template>
                      <template
                        v-if="
                          row.product_type == 'equipment' &&
                          row &&
                          row.preventive_id &&
                          row.preventive_barcode &&
                          row.preventive_id > 0 &&
                          showModules.location
                        "
                      >
                        <v-chip
                          :color="row?.is_consumed ? 'red' : 'cyan darken-2'"
                          class="mr-2 font-weight-600"
                          x-small
                          outlined
                          v-on:click.prevent.stop="
                            routeToDetailLink(
                              row.preventive_id,
                              'admin.preventive-maintanance.detail'
                            )
                          "
                        >
                          {{ row.location }}
                        </v-chip>
                      </template>
                      <v-spacer></v-spacer>

                      <div
                        class="mt-0"
                        v-if="
                          row.product_type == 'equipment' &&
                          row.preventive_id &&
                          row.preventive_id > 0 &&
                          row.is_consumed > 0 &&
                          showModules.preventive_maintanance
                        "
                      >
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="cyan"
                              v-on:click="openSchedule(row.preventive_id)"
                              >mdi-information-outline</v-icon
                            >
                          </template>
                          <span>PM Schedules</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="isPurchaseOrder && !(row.type == 'header')"
                class="text-center px-1"
                style="width: 8%"
              >
                <v-select
                  :menu-props="{ offsetY: true }"
                  v-model="row.po_type"
                  :items="['Quotation', 'Inventory']"
                  :disabled="row.type == 'other' || row.product_type == 'other'"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  color="cyan"
                  class="custom-po-type-select rounded-lg"
                  @change="onPoTypeChange(row)"
                ></v-select>
              </div>
              <div
                v-if="isPurchaseOrder && !(row.type == 'header')"
                class="text-center px-1"
                style="width: 11%"
              >
                <v-text-field
                  class="line-item-header-text px-0 cursor-pointer"
                  placeholder="Select quotation"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  readonly
                  :value="
                    String(row.po_type).toLowerCase() === 'quotation'
                      ? row.linked_quotation || null
                      : '-'
                  "
                  color="cyan"
                  @click="openQuotationModal(row, index)"
                >
                  <template v-slot:append>
                    <v-icon
                      small
                      color="cyan darken-2"
                      @click.stop="openQuotationModal(row, index)"
                    >
                      mdi-format-quote-close
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
              <div
                v-if="isPurchaseOrder && !(row.type == 'header')"
                class="text-center px-1"
                style="width: 11%"
              >
                <v-text-field
                  class="line-item-header-text px-0 cursor-pointer"
                  placeholder="Allocation"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  readonly
                  :value="
                    String(row.po_type).toLowerCase() === 'quotation'
                      ? row.allocation_summary || ''
                      : '-'
                  "
                  color="cyan"
                  @click="
                    String(row.po_type).toLowerCase() === 'quotation' &&
                      openAllocationModal(row, index)
                  "
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="String(row.po_type).toLowerCase() === 'quotation'"
                      small
                      color="cyan darken-2"
                      @click.stop="openAllocationModal(row, index)"
                    >
                      mdi-call-split
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-1"
                :style="{ width: isPurchaseOrder ? '10%' : '12%' }"
              >
                <v-tooltip
                  v-if="
                    isQuotationModule &&
                    hasCustomerQuoteHistory(row) &&
                    !['equipment'].includes(
                      (row.product_type || row.type || '').toLowerCase()
                    )
                  "
                  top
                  content-class="custom-top-tooltip"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <PriceField v-bind="attrs" v-on="on" class="line-item-header-text px-0"
                      placeholder="Selling/Unit Cost" dense filled solo flat hide-details type="text"
                      inputmode="decimal" v-model="row.rate" v-on:keyup="calculate_total()" color="cyan" />
                  </template>
                  <div>
                    Latest price :
                    {{ formatMoney(row.customer_latest_quoted_rate || 0) }}
                  </div>
                </v-tooltip>
                <PriceField v-else class="line-item-header-text px-0" placeholder="Selling/Unit Cost" dense filled
                  solo flat hide-details type="text" inputmode="decimal" v-model="row.rate"
                  v-on:keyup="calculate_total()" color="cyan" />
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-1"
                :style="{ width: isPurchaseOrder ? '7%' : '8%' }"
              >
                <v-autocomplete
                  :menu-props="{ offsetY: true }"
                  dense
                  filled
                  color="cyan"
                  item-color="cyan"
                  :items="unitList"
                  placeholder="UOM"
                  solo
                  flat
                  hide-details
                  item-text="text"
                  item-value="value"
                  class="pr-0 width-100"
                  v-model.trim="row.uom"
                  v-on:change="emit_values()"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="'No UOM Found.'"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-1"
                :style="{ width: isPurchaseOrder ? '7%' : '8%' }"
              >
                <v-text-field
                  class="line-item-header-text px-0"
                  placeholder="Quantity"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  type="number"
                  max="5000"
                  :maxlength="row.product_type == 'service' ? 4 : null"
                  :readonly="row.type == 'equipment' || row.type == 'tools'"
                  v-model="row.quantity"
                  :prepend="row.uom"
                  v-on:keyup="checkAvailableQuantity(row), calculate_total()"
                  v-on:keypress="
                    isNumber($event);
                    row.product_type == 'service' &&
                      limitMaxLength($event, row.quantity, 4);
                  "
                  color="cyan"
                />
              </div>
              <div
                v-if="discount_level == 'line_item' && !(row.type == 'header')"
                class="text-center px-1"
                :style="{ width: isPurchaseOrder ? '10%' : '13%' }"
              >
                <div class="d-flex">
                  <v-text-field
                    hide-details
                    class="line-item-header-text px-0"
                    placeholder="Discount"
                    dense
                    filled
                    solo
                    flat
                    type="number"
                    v-model="row.discount_value"
                    v-on:keyup="calculate_total()"
                    v-on:keypress="
                      limitDecimal($event, row.discount_value),
                        validateDiscountKeypress($event, row)
                    "
                    v-on:paste="validateLineItemDiscountPaste($event, row)"
                    color="cyan"
                    style="width: 60%"
                    :disabled="row.quantity == 0"
                  />
                  <v-select
                    :menu-props="{ offsetY: true }"
                    :items="discount_type_list"
                    v-model="row.discount_type"
                    hide-details
                    item-text="type"
                    item-value="value"
                    item-color="cyan"
                    class="line-item-header-text discount-type px-0 ml-1"
                    placeholder="Type"
                    dense
                    filled
                    solo
                    flat
                    v-on:change="calculate_total(), changeDiscountType2(row)"
                    color="cyan"
                    style="width: 40%"
                  />
                </div>
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-1"
                :style="{ width: isPurchaseOrder ? '6%' : '8%' }"
              >
                <v-text-field
                  class="line-item-header-text px-0 font-weight-600"
                  placeholder="Total"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  type="number"
                  v-model="row.total"
                  v-on:keyup="calculate_total()"
                  v-on:keypress="limitDecimal($event, row.total)"
                  color="cyan"
                />
              </div>
              <div
                class="font-weight-600 d-flex align-items-top justify-center"
                style="width: 4%"
              >
                <template v-if="!row.is_child && relatedType != 7">
                  <v-menu v-if="row.has_child" bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        small
                        color="cyan darken-2"
                      >
                        <v-icon small
                          >mdi-dots-horizontal-circle-outline</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list class="py-0 rounded-lg" min-width="160px">
                      <v-list-item
                        v-if="!row.is_child && !isPurchaseOrder"
                        link
                        class="border-bottom"
                        v-on:click="add_child(index, 'equipment')"
                      >
                        <v-list-item-title class="font-weight-600 font-size-13">
                          Add Equipment</v-list-item-title
                        >
                      </v-list-item>

                      <v-list-item
                        v-if="!row.is_child && relatedType != 7"
                        link
                        class="border-bottom"
                        v-on:click="add_child(index, 'product')"
                      >
                        <v-list-item-title class="font-weight-600 font-size-13">
                          Add Product</v-list-item-title
                        >
                      </v-list-item>

                      <v-list-item
                        v-if="
                          !row.is_child && relatedType != 7 && isPurchaseOrder
                        "
                        link
                        class="border-bottom"
                        v-on:click="add_child(index, 'parts')"
                      >
                        <v-list-item-title class="font-weight-600 font-size-13">
                          Add Part</v-list-item-title
                        >
                      </v-list-item>

                      <v-list-item
                        v-if="
                          !row.is_child && relatedType != 7 && !isPurchaseOrder
                        "
                        link
                        v-on:click="add_child(index, 'service')"
                      >
                        <v-list-item-title class="font-weight-600 font-size-13">
                          Add Service</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
                <v-btn
                  v-on:click="remove_row(index, row)"
                  icon
                  small
                  color="red lighten-1"
                >
                  <v-icon small>mdi-delete-outline</v-icon>
                </v-btn>
              </div>
            </div>
          </li>
        </transition-group>
      </Draggable>
      <template v-if="!selected_line_items.length">
        <div class="p-4 text-center">
          <p
            class="m-0 p-3 font-size-14 font-weight-500 text-slate-600 bg-slate-50 border-slate rounded-lg d-inline-flex align-items-center justify-center"
          >
            <v-icon color="cyan darken-2" small class="mr-2"
              >mdi-alert-circle-outline</v-icon
            >
            No line items added yet. Use the action bar above to add items.
          </p>
        </div>
      </template>
    </v-card>
    <div v-if="false" class="d-flex align-items-center">
      <v-autocomplete
        v-if="relatedType != 7 && !isOpportunity"
        hide-details
        v-model.trim="module_type_bottom"
        :items="modulesTypeComputed"
        clearable
        v-on:click:clear="module_type_bottom = null"
        style="max-width: 220px !important"
        dense
        flat
        filled
        placeholder="Select item type"
        item-color="cyan"
        class="mr-2 custom-boder-color"
        color="cyan"
        solo
        :menu-props="{ offsetY: true }"
        v-on:change="open_dialog($event, 'bottom')"
        item-value="value"
        item-text="text"
      >
      </v-autocomplete>
      <v-autocomplete
        v-if="isOpportunity"
        hide-details
        v-model.trim="module_type_bottom"
        :items="modulesType2"
        clearable
        v-on:click:clear="module_type_bottom = null"
        style="max-width: 220px !important"
        dense
        flat
        filled
        placeholder="Select item type"
        item-color="cyan"
        class="mr-2 custom-boder-color"
        color="cyan"
        solo
        :menu-props="{ offsetY: true }"
        v-on:change="open_dialog($event, 'bottom')"
        item-value="value"
        item-text="text"
      >
      </v-autocomplete>
      <v-btn-toggle color="cyan" group class="rounded-lg">
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="product"
          v-on:click="open_dialog('product')"
          v-if="relatedType != 7 && false"
        >
          Product
        </v-btn>
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="service"
          v-on:click="open_dialog('service')"
          v-if="relatedType != 7 && false"
        >
          Service
        </v-btn>
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="equipment"
          v-if="relatedType == 7"
          v-on:click="open_dialog('equipment')"
        >
          Equipment
        </v-btn>
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="tools"
          v-on:click="open_dialog('tools')"
          v-if="relatedType != 7 && false"
        >
          Equipment/Tools
        </v-btn>
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="header"
          v-on:click="add_header()"
          style="height: 32px !important"
        >
          Header
        </v-btn>
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="other"
          v-on:click="add_other()"
          style="height: 32px !important"
          v-if="relatedType != 7"
        >
          <v-icon small class="mr-1">mdi-plus</v-icon>
          Other
        </v-btn>
      </v-btn-toggle>
    </div>

    <!-- Summary & Totals Box -->
    <div class="d-flex justify-end mb-4">
      <v-card
        flat
        outlined
        class="rounded-lg bg-slate-50 pa-4 border-slate w-100 shadow-0"
        style="max-width: 550px"
      >
        <div
          class="d-flex align-items-center justify-space-between pb-2 mb-3 border-bottom"
        >
          <div class="d-flex align-items-center">
            <v-icon small color="cyan darken-2" class="mr-2"
              >mdi-calculator-variant-outline</v-icon
            >
            <span class="font-size-15 font-weight-700 color-custom-blue"
              >Summary & Totals</span
            >
          </div>
        </div>

        <table width="100%" style="table-layout: fixed">
          <tbody>
            <tr>
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 text-slate-700 py-1"
              >
                Sub Total
              </td>
              <td width="30%" valign="middle" align="center" class="py-1"></td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              >
                {{ formatMoney(subtotal) }}
              </td>
            </tr>
            <tr v-if="discount_level == 'transaction'">
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 text-slate-700 py-1"
              >
                Discount
              </td>
              <td width="30%" valign="middle" align="center" class="py-1">
                <div class="d-flex">
                  <v-text-field
                    hide-details
                    class="line-item-header-text px-0"
                    placeholder="Discount"
                    dense
                    filled
                    solo
                    flat
                    v-model="discount_value"
                    v-on:keyup="calculate_total(), checkData()"
                    v-on:keypress="
                      limitDecimal($event, discount_value),
                        checkData(),
                        manageDiscount($event)
                    "
                    v-on:paste="validateTransactionDiscountPaste($event)"
                    v-on:change="checkData()"
                    color="cyan"
                  />

                  <v-select
                    :menu-props="{ offsetY: true }"
                    :items="discount_type_list"
                    v-model="discount_type"
                    hide-details
                    item-text="type"
                    item-value="value"
                    item-color="cyan"
                    class="line-item-header-text discount-type px-0 ml-1"
                    placeholder="Type"
                    dense
                    filled
                    solo
                    flat
                    v-on:change="calculate_total(), changeDiscountType()"
                    color="cyan"
                  />
                </div>
              </td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              >
                {{ formatMoney(discount) }}
              </td>
            </tr>
            <tr>
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 text-slate-700 py-1"
              >
                Tax [GST {{ gst_value }}%]
              </td>
              <td width="30%" valign="middle" align="center" class="py-1">
                <v-checkbox
                  v-on:change="calculate_total()"
                  v-model="tax_active"
                  class="my-0 py-0 px-0 mx-0"
                  color="cyan"
                  hide-details
                  :label="`Apply Tax`"
                />
              </td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              >
                {{ formatMoney(gst) }}
              </td>
            </tr>
            <tr>
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 text-slate-700 py-1"
              >
                Adjustment
              </td>
              <td width="30%" valign="middle" align="center" class="py-1">
                <v-text-field
                  hide-details
                  class="line-item-header-text px-0 line-item-adjustment"
                  placeholder="Adjustment"
                  dense
                  filled
                  solo
                  flat
                  v-model="adjustment"
                  v-on:keyup="calculate_total(), checkData()"
                  v-on:keypress="
                    limitDecimal($event, adjustment),
                      checkData(),
                      limitMaxLength($event, adjustment, 10)
                  "
                  :maxlength="10"
                  color="cyan"
                >
                  <template v-slot:append>
                    <v-btn
                      x-small
                      depressed
                      color="cyan darken-2 white--text"
                      class="px-2 rounded-sm"
                      v-on:click="auto_adjust()"
                      >Auto</v-btn
                    >
                  </template>
                </v-text-field>
              </td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              >
                {{ formatMoney(adjustment) }}
              </td>
            </tr>
            <tr v-if="show_collected">
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 red--text text--darken-2 py-1"
              >
                Amount to be collected
              </td>
              <td width="30%" valign="middle" align="center" class="py-1">
                <v-text-field
                  class="line-item-header-text px-0"
                  placeholder="Collected Amount"
                  dense
                  filled
                  solo
                  flat
                  v-on:change="calculate_total(), changeDiscountType()"
                  color="cyan"
                />
              </td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              ></td>
            </tr>
          </tbody>
        </table>

        <!-- Grand Total Highlight Banner -->
        <div
          class="d-flex align-items-center justify-space-between pa-3 rounded-lg bg-cyan-50 border-top mt-3"
        >
          <span class="font-size-15 font-weight-700 text-slate-900"
            >Grand Total</span
          >
          <span class="font-size-20 font-weight-800 color-custom-blue">{{
            formatMoney(total)
          }}</span>
        </div>
      </v-card>
    </div>
    <LineItemDialog
      :key="`line-item-dialog-${dialog_key}`"
      :product-type="product_type"
      :isType="relatedType"
      :product-dialog="product_dialog"
      :module-type="relatedType"
      :supplier="supplier"
      :sales-executive="salesExecutive"
      :quotation-id="$route.params.id || 0"
      v-on:update-values="update_line_item($event)"
      v-on:close="closeProductDialog"
    />
    <ManageWarranty
      :dialog-status="addWarrantyDialog"
      v-on:close:dialog="addWarrantyDialog = false"
      v-on:warrnty:data="warrantyData($event)"
    ></ManageWarranty>
    <AddressSelect
      line-item
      :key="`address-select-dialog-${dialog_key}`"
      :dialog="property_dialog"
      v-on:close="property_dialog = false"
      type="property"
      label="Service Location"
      v-on:update="update_child_property($event)"
    />
    <!-- Upload Image :: begin -->
    <div class="d-none">
      <v-file-input
        :ref="`line-item-image`"
        v-on:change="updateProfileImage"
        multiple
        accept="image/png, image/jpeg, image/jpg"
      ></v-file-input>
    </div>
    <PMSchedule
      v-if="scheduleDialog"
      :parent-id="pmId"
      :dialogStatus="scheduleDialog"
      v-on:close:dialog="scheduleDialog = false"
    >
    </PMSchedule>
    <!-- :local-entity="localEntity" -->
    <SerialNumber
      v-if="seleceDialog"
      :key="`serial-number-dialog-${serialDialogKey}`"
      :transaction-detail="transactionDetail"
      :parent-index="numberIndex"
      :dialogStatus="seleceDialog"
      :serial-number="numbersArr"
      :allow-partial="Boolean(isJob || allowPartialSerial)"
      v-on:close:dialog="seleceDialog = false"
      v-on:update:item="savedata"
    >
    </SerialNumber>

    <ManageUnit
      :u-dialog="manageUnitDialog"
      :unit="unitList"
      v-on:close-dialog="manageUnitDialog = false"
      v-on:get-product-unit="getOptions"
    ></ManageUnit>
    <!-- Upload Image :: end -->
    <Dialog :common-dialog="customerChangeDialog" :dialog-width="dialogWidth">
      <template v-slot:title>
        <v-layout class="px-4">
          <v-flex> Customer changed </v-flex>
        </v-layout>
      </template>
      <template v-slot:body>
        <div class="px-4 w-100">
          <p class="mb-0">
            The selected customer was changed and there are product line items
            in the current list. Would you like to keep the current product
            prices or update the prices for the newly selected customer?
          </p>
        </div>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          class="custom-bold-button custom-grey-border"
          text
          color="grey"
          @click="onKeepProductPrices"
          >Keep Prices</v-btn
        >
        <v-btn
          depressed
          class="custom-bold-button"
          color="cyan"
          text-color="white"
          @click="onUpdateProductPrices"
          >Update Prices</v-btn
        >
      </template>
    </Dialog>

    <SelectAcceptedQuotationModal
      v-model="quotationDialog"
      :quotation-list="quotationList"
      @select="onSelectQuotation"
    >
    </SelectAcceptedQuotationModal>

    <AllocateQuantityModal
      v-model="allocationDialog"
      :item-data="selectedRowForAllocation || {}"
      @save="onSaveAllocation"
    >
    </AllocateQuantityModal>
  </div>
</template>

<script>
import { QUERY, GET, POST } from "@/core/services/store/request.module";
import { mapGetters } from "vuex";
import Draggable from "vuedraggable";
import Dialog from "@/view/pages/partials/Dialog.vue";
import AddressSelect from "@/view/components/LineItemAddressSelect.vue";
import LineItemDialog from "@/view/components/LineItemDialog.vue";
import AppConfiguration from "@/core/config/app.config.js";
import PMSchedule from "@/view/pages/preventive-maintanance/PMScheduleView.vue";
import SerialNumber from "@/view/pages/partials/Serial-Number-Select.vue";
import {
  SET_VISIT_LINE_ITEM,
  SET_VISIT_CALCULATION,
} from "@/core/services/store/visit.module";
import {
  UPDATE_SCHEDULE_LIST,
  UPDATE_SCHEDULE_LIST_QUOTE,
  UPDATE_SCHEDULE_STATE,
} from "@/core/services/store/invoice.module";
import { toBtxNumber, toBtxFixed } from "@/core/services/common.service";
import CommonMixin from "@/core/plugins/common-mixin.js";
import { find } from "lodash";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { v4 as uuidv4 } from "uuid";
import ManageWarranty from "@/view/pages/partials/Create-Warranty-Intenal.vue";
import moment from "moment-timezone";
import ManageUnit from "@/view/pages/partials/Manage-Part-Unit.vue";
import SelectAcceptedQuotationModal from "@/view/pages/partials/SelectAcceptedQuotationModal.vue";
import AllocateQuantityModal from "@/view/pages/partials/AllocateQuantityModal.vue";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
export default {
  name: "line-item-v1",
  model: {
    prop: "value",
    event: "input",
  },
  mixins: [CommonMixin],
  data() {
    return {
      drag: false,
      pmData: [],
      unitList: [],
      manageUnitDialog: false,
      module_type_top: null,
      module_type_bottom: null,
      transactionDetail: {},
      numbersArr: [],
      seleceDialog: false,
      numberIndex: 0,
      serialDialogKey: 0,
      modulesType: [
        {
          value: "goods",
          text: "Product",
          show: true,
        },
        {
          value: "parts",
          text: "Part",
          show: true,
        },
        {
          value: "service",
          text: "Service",
          show: true,
        },
        {
          value: "equipment",
          text: "Equipment",
          show: true,
        },
      ],
      modulesType2: [
        {
          value: "goods",
          text: "Product",
          show: true,
        },
        {
          value: "parts",
          text: "Part",
          show: true,
        },
        {
          value: "service",
          text: "Service",
          show: true,
        },
      ],
      dialog_key: Number(new Date()),
      product_type: null,
      product_dialog: false,
      dialog_position: false,
      child_index: null,
      addWarrantyDialog: false,
      append_child: false,
      warrantyObject: {},
      property_dialog: false,
      tax_active: false,
      do_update: 0,
      pageLoading: false,
      show_price: false,
      transactions: [
        {
          text: "Transaction",
          value: "transaction",
        },
        {
          text: "Line Item",
          value: "line_item",
        },
      ],
      discount_level: "transaction",
      imageRules: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          "Image size should be less than 2 MB!",
      ],
      imageSrc: [],
      selected_line_items: [],
      currentEntityDb: {},
      subtotal: 0,
      collected_amount: 0,
      discount: 0,
      scheduleDialog: false,
      pmId: 0,
      gst: 0,
      gst_amount: 0,
      gst_value: 9,
      adjustment: 0,
      total_non_text_amount: 0,
      total: 0,
      customIndex: 0,
      discount_value: null,
      discount_type: 1,
      /*   localEntity: [], */
      discount_type_list: [
        { type: "%", value: 2 },
        { type: "$", value: 1 },
      ],
      show_collected: false,
      is_lump_sum: false,
      customerChangeDialog: false,
      pendingNewCustomerId: null,
      previousCustomerId: null,
      lastUpdateParam: null,
      duplicate_line_item_found: false,
      quotationDialog: false,
      quotationList: [],
      quotationListLoaded: false,
      selectedQuotation: null,
      allocationDialog: false,
      selectedRowForAllocation: null,
    };
  },
  props: {
    isDuplicate: {
      type: Boolean,
      default: false,
    },
    allowPartialSerial: {
      type: Boolean,
      default: false,
    },
    isPurchaseOrder: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    relatedDetail: {
      type: Object,
      default: null,
    },
    unit: {
      type: Array,
      default() {
        return [];
      },
    },
    dbLineItems: {
      type: Array,
      default() {
        return [];
      },
    },
    dbEquipments: {
      type: Array,
      default() {
        return [];
      },
    },
    entityId: {
      type: Number,
      default: 0,
    },
    isJob: {
      type: Boolean,
      default: false,
    },
    isCollected: {
      type: Boolean,
      default: false,
    },
    relatedType: {
      type: Number,
      default: 3,
    },
    isCustomerRequired: {
      type: Boolean,
      default: false,
    },
    isEnquiry: {
      type: Boolean,
      default: false,
    },
    isQuotation: {
      type: Boolean,
      default: false,
    },
    isPreventive: {
      type: Boolean,
      default: false,
    },
    itemSet: {
      type: Boolean,
      default: false,
    },

    isProject: {
      type: Boolean,
      default: false,
    },
    isOpportunity: {
      type: Boolean,
      default: false,
    },
    itemSource: {
      type: String,
      default: null, // null = no merging (Create-Quotation), "quotation"/"contract" = merge (Create-Job)
    },
    supplier: {
      type: [Number, String],
      default: 0,
    },
    salesExecutive: {
      type: [Number, String],
      default: 0,
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(items) {
        if (items !== this.selected_line_items) {
          this.selected_line_items = Array.isArray(items) ? items : [];
        }
      },
    },
    salesExecutive: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.refreshCustomerLatestQuotedRates();
        }
      },
    },
    vCustomerId(newCustomerId) {
      if (!newCustomerId) {
        return;
      }

      const oldCustomerId = this.previousCustomerId;

      if (newCustomerId !== oldCustomerId) {
        const hasProducts = this.selected_line_items.some((item) => {
          if (!item) return false;
          const pt = (item.product_type || "").toString().toLowerCase();
          return ["goods", "product", "service"].includes(pt);
        });

        if (hasProducts) {
          this.pendingNewCustomerId = newCustomerId;
          this.customerChangeDialog = true;
          return;
        }

        // If there are no selected products, remove equipment-only line items as before
        this.selected_line_items = this.selected_line_items.filter(
          (item) => item.product_type !== "equipment"
        );
        this.calculate_total();
        this.emit_values();
      }

      // Always update previousCustomerId once we have a real value
      this.previousCustomerId = newCustomerId;
    },
    selected_line_items: {
      deep: true,
      handler(items) {
        clearTimeout(this.qtyWatcherTimer);

        this.qtyWatcherTimer = setTimeout(() => {
          items.forEach((row) => {
            const qty = toBtxNumber(row.quantity);
            const rate = toBtxNumber(row.rate);
            const lineTotal = qty * rate;

            if (qty === 0) {
              row.discount_value = null;
              row.total = 0;
              return;
            }

            if (row.discount_type == 1 && row.discount_value > lineTotal) {
              row.discount_value = 0;
            }

            if (row.discount_type == 2 && row.discount_value > 100) {
              row.discount_value = 100;
            }
          });

          this.calculate_total();
        }, 300);
      },
    },
    relatedDetail: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param && param.line_item) {
          this.selected_line_items = param.line_item;
          this.selected_line_items.forEach((item) => {
            if (
              item.isSerialized == 1 ||
              item.serial_number == 1 ||
              (item.main_product && item.main_product.serial_number == 1) ||
              (item.serialize_number && item.serialize_number.length > 0)
            ) {
              item.isSerialized = 1;
            }
            if (this.isDuplicateMode) {
              item.serialNumber = [];
              item.adjust_serial_array = [];
              item.serialize_number = [];
              item.serial_numbers_input = [];
              item.assigned_quantity = 0;
            } else if (
              item.serialize_number &&
              item.serialize_number.length &&
              (!item.serialNumber || !item.serialNumber.length)
            ) {
              const mappedSerials = item.serialize_number.map((x) =>
                typeof x === "object" ? x.serial_number_id || x.id : Number(x)
              );
              item.serialNumber = mappedSerials;
              item.adjust_serial_array = mappedSerials;
            }
          });
          this.initializeLumpSum();
        }
        if (param && param.id && param.id > 0 && !this.isPurchaseOrder) {
          this.get_line_items(param);
        }
        // Set lump sum checkbox based on quotation type
        if (param && param.quotation_type == 1) {
          this.is_lump_sum = true;
        }
      },
    },
    itemSet: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.selected_line_items = this.vSelectedLineItem;
          this.selected_line_items.map((row, index) => {
            this.selected_line_items[index].discount_type =
              this.lodash.toSafeInteger(row.discount_type);
            this.selected_line_items[index].cimages = row.item_images;
          });
          (this.show_price = param.show_price == 1 ? true : false),
            (this.adjustment = param.adjustment);
          this.gst_value =
            param.tax_value > 0
              ? param.tax_value
              : this.currentEntityDb.gstvalue;
          this.tax_active = param.tax_applied == 1 ? true : false;
          this.discount_level =
            param.discount_type == 1 ? "transaction" : "line_item";
          this.uom = param.uom ?? null;
          if (param && param.discount_value_type) {
            this.discount_value = param.discount_value;
            this.discount_type = this.lodash.toSafeInteger(
              param.discount_value_type
            );
          }
          this.calculate_total();
        }
      },
    },
    isCollected: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.show_collected = true;
        } else {
          this.show_collected = false;
        }
      },
    },
    // selected_line_items: {
    // deep: true,
    // handler(items) {
    //     items.forEach(row => {
    //       if (Number(row.quantity) === 0) {
    //         row.discount_value = null
    //       }
    //     })
    //   }
    // },
    /*  warrantyObject: {
          deep: true,
          immediate: true,
          handler(param) {
            console.log(param, "paramparamparam");

          },
        }, */
  },
  methods: {
    validateSellingCostInput(event) {
      if (
        event.ctrlKey ||
        event.metaKey ||
        [
          "Backspace",
          "Delete",
          "ArrowLeft",
          "ArrowRight",
          "Home",
          "End",
          "Tab",
          "Enter",
          "Escape",
          "Shift",
        ].includes(event.key)
      ) {
        return;
      }

      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const nextValue = value.slice(0, start) + event.key + value.slice(end);

      if (
        event.key.length !== 1 ||
        !/^\d{0,6}(?:\.\d{0,2})?$/.test(nextValue)
      ) {
        event.preventDefault();
      }
    },
    validateSellingCostPaste(event) {
      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const pastedValue = event.clipboardData.getData("text");
      const nextValue = value.slice(0, start) + pastedValue + value.slice(end);

      if (!/^\d{0,6}(?:\.\d{0,2})?$/.test(nextValue)) {
        event.preventDefault();
      }
    },
    hasCustomerQuoteHistory(row) {
      return row && Number(row.customer_latest_quoted_rate) > 0;
    },
    customerQuoteProductType(row) {
      const type = (row?.product_type || "product").toString();
      return type.charAt(0).toUpperCase() + type.slice(1);
    },
    validateDiscountKeypress(event, row) {
      const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
      ];
      if (allowedKeys.includes(event.key)) return;

      const currentValue = event.target.value || "";
      const nextValue = Number(currentValue + event.key);

      // % discount → max 100 ONLY
      if (row.discount_type == 2) {
        if (nextValue > 100) {
          event.preventDefault();
        }
        return;
      }

      // flat discount → max rate
      const rate = Number(row.rate || 0);
      if (nextValue > rate) {
        event.preventDefault();
      }
    },
    validateLineItemDiscountPaste(event, row) {
      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const pastedValue = event.clipboardData.getData("text");
      const nextValue =
        value.substring(0, start) + pastedValue + value.substring(end);

      if (!/^\d*(?:\.\d{0,2})?$/.test(nextValue)) {
        event.preventDefault();
        return;
      }

      const discountValue = Number(nextValue);
      const exceedsLimit =
        (row.discount_type == 1 && discountValue > Number(row.rate || 0)) ||
        (row.discount_type == 2 && discountValue > 100);

      if (exceedsLimit) {
        event.preventDefault();
      }
    },
    validateTransactionDiscountPaste(event) {
      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const pastedValue = event.clipboardData.getData("text");
      const nextValue =
        value.substring(0, start) + pastedValue + value.substring(end);

      if (!/^\d*(?:\.\d{0,2})?$/.test(nextValue)) {
        event.preventDefault();
        return;
      }

      const discountValue = Number(nextValue);
      const exceedsLimit =
        (this.discount_type == 1 && discountValue > Number(this.subtotal)) ||
        (this.discount_type == 2 && discountValue > 100);

      if (exceedsLimit) {
        event.preventDefault();
      }
    },
    changeDiscountType2(row) {
      if (row.discount_type == 2) {
        if (Number(row.discount_value) > 100) {
          row.discount_value = 100;
        }
      }

      // Flat discount
      if (row.discount_type == 1) {
        row.discount_value = 0;
      }

      this.calculate_total();
    },

    changeDiscountType() {
      if (this.discount_type == 2 && this.discount_value > 100) {
        this.discount_value = 100;
      }
      this.calculate_total();
    },
    manageDiscount($event) {
      const e = $event;
      const input = e.target;
      const key = e.key || String.fromCharCode(e.which || e.keyCode);
      if (
        ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(
          event.key
        )
      ) {
        return;
      }
      const newValue =
        input.value.substring(0, input.selectionStart) +
        key +
        input.value.substring(input.selectionEnd);
      if (isNaN(newValue)) {
        e.preventDefault();
        return;
      }
      if (
        (Number(newValue) > Number(this.subtotal) && this.discount_type == 1) ||
        (Number(newValue) > 100 && this.discount_type == 2)
      ) {
        e.preventDefault();
        return;
      }
    },
    getOptions() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "setting/get-all-unit",
        })
        .then((response) => {
          _this.unitList = response.data;
          _this.$emit("close-dialog", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    getSerialCount(row) {
      if (!row) return 0;
      const serials =
        (Array.isArray(row.serialNumber) && row.serialNumber.length
          ? row.serialNumber
          : null) ||
        (Array.isArray(row.adjust_serial_array) &&
        row.adjust_serial_array.length
          ? row.adjust_serial_array
          : null) ||
        (Array.isArray(row.serialize_number) && row.serialize_number.length
          ? row.serialize_number
          : null) ||
        (Array.isArray(row.serial_numbers_input) &&
        row.serial_numbers_input.length
          ? row.serial_numbers_input
          : null) ||
        [];
      if (serials.length > 0) return serials.length;
      if (
        typeof row.assigned_quantity !== "undefined" &&
        row.assigned_quantity !== null
      ) {
        return Number(row.assigned_quantity);
      }
      return 0;
    },
    isPartialSerial(row) {
      const count = this.getSerialCount(row);
      const qty = Number(row?.quantity || 0);
      return count < qty;
    },
    getSerialTagColor(row) {
      const count = this.getSerialCount(row);
      const qty = Number(row?.quantity || 0);
      if (count === 0 || count < qty) {
        return "orange darken-2";
      }
      if (count > qty) {
        return "red darken-1";
      }
      return "teal darken-1";
    },
    getSerialTooltipText(row) {
      const count = this.getSerialCount(row);
      const qty = Number(row?.quantity || 0);
      if (count === 0) {
        return `No serial numbers selected (0 of ${qty})`;
      }
      if (count < qty) {
        return `${count} of ${qty} serial numbers selected (${
          qty - count
        } remaining)`;
      }
      if (count > qty) {
        return `Selected count (${count}) exceeds quantity (${qty})`;
      }
      return `All ${qty} serial number(s) selected`;
    },
    savedata(data) {
      if (this.selected_line_items && this.selected_line_items[data.index]) {
        const item = this.selected_line_items[data.index];
        const serials = Array.isArray(data.data) ? data.data : [];
        this.$set(item, "serialNumber", serials);
        this.$set(item, "adjust_serial_array", serials);
        this.$set(item, "serial_numbers_input", serials);
        this.$set(item, "serialize_number", serials);
        this.$set(item, "assigned_quantity", serials.length);
        this.$store.dispatch(SET_VISIT_LINE_ITEM, this.selected_line_items);
      }
      this.seleceDialog = false;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    optionSerial(row, index) {
      const visitId = this.isDuplicateMode
        ? 0
        : Number(
            this.relatedType == 3 && this.relatedDetail?.id
              ? this.relatedDetail.id
              : row?.visit_id ||
                  row?.visit ||
                  this.$route?.query?.visit ||
                  (this.relatedType == 3 ? row?.parent : 0) ||
                  this.relatedDetail?.id ||
                  0
          );

      const productId = Number(
        row?.product_id ||
          row?.main_product_id ||
          row?.main_product?.id ||
          (typeof row?.product === "object" ? row.product?.id : row?.product) ||
          0
      );

      const currentSerials =
        (Array.isArray(row?.serial_numbers_input) &&
        row.serial_numbers_input.length
          ? row.serial_numbers_input
          : null) ||
        (Array.isArray(row?.serialNumber) && row.serialNumber.length
          ? row.serialNumber
          : null) ||
        (Array.isArray(row?.adjust_serial_array) &&
        row.adjust_serial_array.length
          ? row.adjust_serial_array
          : null) ||
        (Array.isArray(row?.serialize_number) && row.serialize_number.length
          ? row.serialize_number
          : null) ||
        [];

      const normalizedCurrentSerials = currentSerials
        .map((x) =>
          typeof x === "object"
            ? Number(x?.serial_number_id || x?.id || 0)
            : Number(x)
        )
        .filter((id) => id > 0);

      this.transactionDetail = {
        ...row,
        id: this.isDuplicateMode ? 0 : Number(row?.id || 0),
        product_id: productId,
        product:
          row?.product_name ||
          row?.title ||
          (typeof row?.product === "string"
            ? row.product
            : "Product Information"),
        barcode:
          row?.barcode ||
          row?.product_barcode ||
          row?.main_product?.barcode ||
          "",
        quantity: Number(row?.quantity || 0),
        parent: visitId,
        visit_id: visitId,
        visit: visitId,
        serialNumber: normalizedCurrentSerials,
        serialize_number: normalizedCurrentSerials,
        adjust_serial_array: normalizedCurrentSerials,
        selected_serial_ids: normalizedCurrentSerials,
      };

      this.numbersArr = normalizedCurrentSerials;
      this.numberIndex = index;
      this.serialDialogKey += 1;
      this.seleceDialog = true;
    },
    checkAvailableQuantity(row) {
      if (Number(row.quantity) > 5000) {
        ErrorEventBus.$emit("update:error", "Quantity cannot exceed 5000");
        row.quantity = 5000;
      }

      /*  if (
        !this.isPurchaseOrder &&
        (row.product_type == "goods" || row.product_type == "parts")
      ) {
        if (Number(row.quantity) > Number(row.initial_stock)) {
          ErrorEventBus.$emit(
            "update:error",
            "Initial quantity cannot be greater than current stock"
          );
          row.quantity = row.initial_stock;
        }
      } */
      if (
        row.serialNumber &&
        Array.isArray(row.serialNumber) &&
        row.serialNumber.length > Number(row.quantity || 0)
      ) {
        row.serialNumber = row.serialNumber.slice(0, Number(row.quantity || 0));
        row.adjust_serial_array = row.serialNumber;
        row.serial_numbers_input = row.serialNumber;
        row.serialize_number = row.serialNumber;
        row.assigned_quantity = row.serialNumber.length;
      }
    },
    selectImage(index) {
      this.customIndex = index;
      this.$refs[`line-item-image`].$refs["input"].click();
    },
    async updateProfileImage(param) {
      if (param && param.length) {
        const promises = [];
        for (let i = 0; i < param.length; i++) {
          const image = await this.convertImageToBase64(param[i]);
          promises.push(image);
        }
        const lineItems = this.lodash.cloneDeep(this.selected_line_items);
        const _cimage = lineItems[this.customIndex].cimages
          ? lineItems[this.customIndex].cimages
          : [];
        lineItems[this.customIndex].cimages = [..._cimage, ...promises];
        this.selected_line_items = lineItems;
        this.$nextTick(() => {
          this.emit_values();
        });
        this.$refs[`line-item-image`].$refs["input"].value = null;
        this.imageSrc = [];
      }
    },
    convertImageToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          this.imageSrc.push(reader.result);
          resolve(reader.result);
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsDataURL(file);
      });
    },
    removeImage(index, pIndex) {
      this.selected_line_items[pIndex].cimages.splice(index, 1);
    },
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    auto_adjust() {
      let total = toBtxNumber(this.total);
      if (total > 0) {
        let adjustment = toBtxFixed(total / 10) * 10 - total;
        this.adjustment = toBtxFixed(adjustment);
        this.$nextTick(() => {
          this.calculate_total();
        });
      }
    },
    routeToDetail(data) {
      let routeName = null;
      if (data.product_type == "equipment") {
        routeName = "client-equipment.detail";
      } else if (data.product_type == "tools") {
        routeName = "equipment.detail";
      } else if (data.product_type == "goods") {
        routeName = "product.detail";
      } else if (data.product_type == "service") {
        routeName = "service.detail";
      } else if (data.product_type == "parts") {
        routeName = "part.detail";
      }
      if (data && data.product_id && data.product_id > 0) {
        this.$router.replace(
          this.getDefaultRoute(routeName, {
            params: { id: data.product_id },
          })
        );
      }
    },
    get_col_style(param, child) {
      let width = 46;
      if (param == "product") {
        width = 46;
        if (this.discount_level == "transaction") {
          width = 70;
        }
      }
      return { width: child ? `${width - 5}%` : `${width}%` };
    },
    calculate_total() {
      let d_type = this.discount_level;

      this.subtotal = 0;
      this.discount = 0;
      this.gst = 0;
      this.gst_amount = 0;
      this.total_non_text_amount = 0;

      for (let i = 0; i < this.selected_line_items.length; i++) {
        let total = this.accountingToFixed(
          toBtxNumber(this.selected_line_items[i].quantity) *
            toBtxNumber(this.selected_line_items[i].rate)
        );
        let discount = 0;

        if (d_type == "line_item") {
          if (
            this.lodash.toSafeInteger(
              this.selected_line_items[i].discount_type
            ) == 1
          ) {
            discount = toBtxNumber(this.selected_line_items[i].discount_value);
          }
          if (
            this.lodash.toSafeInteger(
              this.selected_line_items[i].discount_type
            ) == 2
          ) {
            discount = this.accountingToFixed(
              (toBtxNumber(total) *
                toBtxNumber(this.selected_line_items[i].discount_value)) /
                100
            );
          }
        }
        this.selected_line_items[i].total =
          isNaN(total) || !total
            ? 0
            : toBtxNumber(total) - toBtxNumber(discount);
        this.subtotal = this.accountingToFixed(
          toBtxNumber(this.subtotal) +
            toBtxNumber(this.selected_line_items[i].total)
        );
      }

      let subtotal = this.subtotal;

      if (d_type == "transaction") {
        this.discount = 0;
        if (this.discount_type == 1) {
          this.discount = toBtxNumber(this.discount_value);
          if (this.discount > subtotal) {
            this.discount_value = 0;
            this.discount = 0;
          }
        }
        if (this.discount_type == 2) {
          this.discount = this.accountingToFixed(
            (toBtxNumber(subtotal) * toBtxNumber(this.discount_value)) / 100
          );
        }
      }

      subtotal = toBtxNumber(subtotal) - toBtxNumber(this.discount);

      this.total_non_text_amount = subtotal;
      if (this.tax_active) {
        this.gst_amount = subtotal;
        this.gst = this.accountingToFixed(
          (toBtxNumber(subtotal) * toBtxNumber(this.gst_value)) / 100
        );
      }

      subtotal = toBtxNumber(subtotal) + toBtxNumber(this.gst);

      this.total = this.accountingToFixed(
        toBtxNumber(subtotal) + toBtxNumber(this.adjustment)
      );
      if (!this.relatedDetail?.id) {
        this.collectedAmountEmit();
      }
      this.emit_values();
      if (this.relatedType == 3) {
        this.generateInvoiceSchedule();
      }
      if (this.relatedType == 1 && !this.isEdit) {
        this.generateInvoiceScheduleQuote();
        /* this.$store.commit(UPDATE_SCHEDULE_STATE, {
          key: "isEdit",
          value: false,
        }); */
      }
    },
    getLineItemSelectionKey(item) {
      if (!item) {
        return null;
      }

      let productType = (item.product_type || item.type || "")
        .toString()
        .toLowerCase();

      const productTypeAliases = {
        product: "goods",
        part: "parts",
      };
      productType = productTypeAliases[productType] || productType;

      // Equipment and tools represent individual assets, so their barcode is
      // the identity when it is available. Products, parts, and services
      // must be unique by product id even when their barcode is missing.
      if (
        (productType === "equipment" || productType === "tools") &&
        item.barcode
      ) {
        return `${productType}:barcode:${item.barcode}`;
      }

      const productId =
        item.product_id ??
        item.main_product_id ??
        item.main_product?.id ??
        item.product?.id;
      if (productId !== null && productId !== undefined && productId !== "") {
        return `${productType}:product:${productId}`;
      }

      return null;
    },
    getUniqueLineItems(items) {
      const selectedKeys = new Set(
        this.selected_line_items
          .map((item) => this.getLineItemSelectionKey(item))
          .filter(Boolean)
      );
      const uniqueItems = [];
      let hasDuplicate = false;
      const duplicateMessages = [];

      items.forEach((item) => {
        const key = this.getLineItemSelectionKey(item);

        if (key && selectedKeys.has(key)) {
          hasDuplicate = true;
          const duplicateLabel = item?.barcode || item?.product || "Item";
          duplicateMessages.push(`${duplicateLabel} already used `);
          return;
        }

        uniqueItems.push(item);
        if (key) {
          selectedKeys.add(key);
        }
      });

      if (hasDuplicate) {
        this.duplicate_line_item_found = true;
        ErrorEventBus.$emit("update:error", duplicateMessages);
      }

      return uniqueItems;
    },
    collectedAmountEmit() {
      this.collected_amount = this.total;
    },
    update_line_item(param) {
      this.duplicate_line_item_found = false;
      param = this.getUniqueLineItems(Array.isArray(param) ? param : []);
      if (this.duplicate_line_item_found) {
        return;
      }
      if (!param.length) {
        return;
      }

      // store param globally for further usage elsewhere in the component
      try {
        this.lastUpdateParam = this.lodash.cloneDeep(param);
      } catch (e) {
        this.lastUpdateParam = param;
      }
      for (let item of param) {
        if (item.serial_number == 1 || item.isSerialized == 1) {
          item.isSerialized = 1;
        }
      }
      if (this.append_child) {
        let child_index = toBtxNumber(this.child_index);
        for (let item of param) {
          item.is_child = true;
          child_index = child_index + 1;
          this.selected_line_items = this.arrayInsert(
            this.selected_line_items,
            child_index,
            item
          );
        }
      } else if (this.dialog_position == "bottom") {
        {
          for (let item of param) {
            this.selected_line_items.push(item);
          }
        }
      } else if (this.dialog_position === "top") {
        for (let item of param) {
          this.selected_line_items.unshift(item);
        }
      } else {
        for (let item of param) {
          this.selected_line_items.push(item);
        }
      }

      this.calculate_total();

      this.$nextTick(() => {
        this.emit_values();
        if (!this.duplicate_line_item_found) {
          this.product_dialog = false;
          this.append_child = false;
          this.product_type = null;
          this.child_index = null;
        }
        this.duplicate_line_item_found = false;
        if (
          this.isQuotationModule &&
          Number(this.salesExecutive) > 0 &&
          Number(this.vCustomerId) > 0
        ) {
          const hasMissingRate = this.selected_line_items.some(
            (item) =>
              item &&
              ["goods", "service"].includes(
                (item.product_type || "").toString().toLowerCase()
              ) &&
              item.customer_latest_quoted_rate === undefined
          );
          if (hasMissingRate) {
            this.refreshCustomerLatestQuotedRates();
          }
        }
      });
    },
    remove_property(index) {
      this.selected_line_items[index].property = new Object();

      this.$nextTick(() => {
        this.emit_values();
      });
    },
    checkData() {
      if (this.discount_type == 2 && this.discount_value) {
        if (this.discount_value > 100) {
          this.discount_value = 100;
        }
      }
    },
    changeEquipment(index, row) {
      this.selected_line_items[index].is_equipment = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    changeDes(index, row) {
      this.selected_line_items[index].description = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    changeName(index, row) {
      const trimmedValue = row.trim();
      this.selected_line_items[index].product = trimmedValue || "";
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    OpenchangeWarrnty(index) {
      this.eIndex = index;
      this.addWarrantyDialog = true;
    },
    generateInvoiceSchedule() {
      let invoiceArray = [];
      invoiceArray = this.rawScheduleOutput.map((item) => ({
        daysOfWeek: item?.daysOfWeek,
        startDate: item?.startDate,
        dueDate: this.dueDate(item?.startDate),
        billing_amount: this.total,
        status: 1,
        isEdited: 0,
        isDisabled: 0,
        isPrimary: 0,
        uuid: item?.uuid,
      }));
      this.$store.commit(UPDATE_SCHEDULE_LIST, {
        key: "dbInvoiceVisitScheduleOutput",
        value: invoiceArray,
      });
    },
    dueDate(date) {
      let day = 15;
      if (this.recurringinvoice?.payment_due == 2) {
        day = 15;
      } else if (this.recurringinvoice?.payment_due == 3) {
        day = 30;
      } else if (this.recurringinvoice?.payment_due == 4) {
        day = 45;
      }
      let dueData = moment(date).add(day, "days").format("YYYY-MM-DD");
      return dueData;
    },
    generateInvoiceScheduleQuote() {
      /*  let invoiceArray = []; */
      let invoiceArrayTotelAmt = [];
      let total = 0;
      if (this.quoteInvoiceParameters?.invoice_amount_type == "total_amount") {
        total = this.total_non_text_amount;
      } else {
        total =
          this.total_non_text_amount /
          Number(this.invoiceRecurringSchedule?.occurrence);
      }
      invoiceArrayTotelAmt = this.invoiceScheduleOutput?.map((item) => ({
        daysOfWeek: item?.daysOfWeek,
        startDate: item?.startDate,
        dueDate: this.dueDateQue(item?.startDate),
        billing_amount: total,
        status: 1,
        isEdited: 0,
        isDisabled: 0,
        isPrimary: 0,
        otherItem: item?.otherItem ?? [],
        toatalAmt: item?.toatalAmt ?? 0,
      }));
      this.$store.commit(UPDATE_SCHEDULE_LIST_QUOTE, {
        key: "dbScheduleOutput",
        value: invoiceArrayTotelAmt,
      });
    },
    dueDateQue(date) {
      let day = 15;
      if (this.quoteInvoiceParameters?.payment_due == 2) {
        day = 15;
      } else if (this.quoteInvoiceParameters?.payment_due == 3) {
        day = 30;
      } else if (this.quoteInvoiceParameters?.payment_due == 4) {
        day = 45;
      }
      let dueData = moment(date).add(day, "days").format("YYYY-MM-DD");
      return dueData;
    },
    warrantyData(data) {
      this.selected_line_items[this.eIndex].equipment_warranty = 0;
      this.selected_line_items[this.eIndex].warranty_cost = data.cost;
      this.selected_line_items[this.eIndex].warranty_description =
        data.description;
      this.selected_line_items[this.eIndex].warranty_duration = data.duration;
      this.selected_line_items[this.eIndex].warranty_duration_type =
        data.duration_type;
      this.selected_line_items[this.eIndex].warranty_end_date = data.end_date;
      this.selected_line_items[this.eIndex].warranty_start_date =
        data.start_date;
      this.selected_line_items[this.eIndex].warranty_unique_id = data.unique_id;
      this.selected_line_items[this.eIndex].warranty_type = data.warranty_type;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    changeWarrnty(index, row) {
      this.selected_line_items[index].equipment_warranty =
        row.equipment_warranty;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    update_child_property(row) {
      this.selected_line_items[this.child_index].property = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    add_child(index, type) {
      this.append_child = true;
      this.dialog_key = Number(new Date());
      this.child_index = index;
      if (
        (type == "property" || type == "equipment" || type == "tools") &&
        !this.isCustomerRequired
      ) {
        if (!this.vCustomerId && !type == "tools") {
          this.scrollToTop();
          ErrorEventBus.$emit("update:error", "Please Select Customer.");
          return false;
        }
        if (type == "equipment") {
          this.product_type = type;
          this.product_dialog = true;
        } else if (type == "tools") {
          this.product_type = type;
          this.product_dialog = true;

          /*     this.property_dialog = true; */
        } else {
          this.property_dialog = true;
        }
      }
      if (type == "product" || type == "parts") {
        this.product_type = type;
        this.product_dialog = true;
      }

      if (type == "service") {
        this.product_type = type;
        this.product_dialog = true;
      }
    },
    emit_values() {
      this.$nextTick(() => {
        const payload = {
          discount_type: this.lodash.toSafeInteger(this.discount_type),
          discount_value: this.discount_value,
          tax_active: this.tax_active,
          adjustment: this.adjustment,
          collected_amount: this.collected_amount,
          uom: this.uom,
          visit_amount: this.total,
          show_price: this.show_price,
          discount_level: this.discount_level,
          calculate_total: this.calculate_total,
          tax_value: this.gst_value,
          total_non_text_amount: this.total_non_text_amount,
        };

        // Only include is_lump_sum for quotations
        if (this.isQuotation) {
          payload.is_lump_sum = this.is_lump_sum ? 1 : 0;
        }

        this.$store.dispatch(SET_VISIT_CALCULATION, payload);
        this.$store.dispatch(SET_VISIT_LINE_ITEM, this.selected_line_items);
        this.$emit("input", this.selected_line_items);
        this.$emit("update:total", {
          calculation: payload,
          "line-item": this.selected_line_items,
        });
      });
    },

    open_dialog(param, position) {
      if (!param) {
        return false;
      }
      if (!position) {
        this.position = null;
      }

      if (
        param === "equipment" &&
        !this.vCustomerId &&
        !this.isCustomerRequired
      ) {
        this.scrollToTop();
        ErrorEventBus.$emit("update:error", "Please Select Customer.");
        return false;
      }

      this.dialog_key = Number(new Date());
      this.product_type = param;
      this.product_dialog = true;
      this.dialog_position = position;
    },
    closeProductDialog() {
      const keepOpen = this.duplicate_line_item_found;
      this.duplicate_line_item_found = false;
      this.product_dialog = keepOpen;
      if (!keepOpen) {
        this.module_type_top = null;
      }
    },
    add_header() {
      let len = this.selected_line_items.length + 1;
      this.selected_line_items.push({
        status: true,
        index: uuidv4(),
        uuid: uuidv4(),
        id: 0,
        order: len,
        type: "header",
        product_type: "header",
        is_child: false,
        has_child: false,
        has_property: false,
        product: null,
      });
      this.$nextTick(() => {
        this.product_type = null;
        this.emit_values();
      });
    },
    add_other() {
      let len = this.selected_line_items.length + 1;
      this.selected_line_items.push({
        status: true,
        index: uuidv4(),
        uuid: uuidv4(),
        id: null,
        image: {},
        order: len,
        serial_no: null,
        eq_model: null,
        location: null,
        group: null,
        discount: 0,
        type: "other",
        is_child: false,
        parent_uuid: null,
        has_child: true,
        has_property: true,
        property: {},
        group_primary: false,
        discount_value: 0,
        discount_type: 1,
        to_equipment: 0,
        product: null,
        project_price: 0,
        threshold_price: 0,
        product_id: 0,
        product_type: "other",
        description: null,
        has_warranty: false,
        warranty: {},
        rate: 0,
        selling_cost: 0,
        quantity: 1,
        uom: null,
        total: 0,
      });
      this.$nextTick(() => {
        this.product_type = null;
        this.emit_values();
      });
    },
    get_line_items(param) {
      let id = param.id;

      this.$store.commit("setLineItemLoading", true);
      this.$store
        .dispatch(QUERY, {
          url: `visit-v1/${id}/line-items`,
          data: {
            type: this.relatedType,
            sales_executive:
              Number(this.salesExecutive) > 0
                ? Number(this.salesExecutive)
                : null,
          },
        })
        .then(({ data }) => {
          let source = this.itemSource; // Use prop instead of type-based logic

          if (source) {
            // For quotation/contract: keep other sources and merge
            let existingItems = this.selected_line_items || [];
            existingItems = existingItems.filter(
              (item) => item.line_item_source !== source
            );

            // Tag newly fetched items
            data = data.map((item) => ({
              ...item,
              line_item_source: source,
            }));
            this.selected_line_items = [...existingItems, ...data];
          } else {
            // For no source: replace entirely (don't merge)
            this.selected_line_items = data;
          }

          this.selected_line_items.map((row, index) => {
            this.selected_line_items[index].discount_type =
              this.lodash.toSafeInteger(row.discount_type);
            this.selected_line_items[index].cimages = row.item_images;
            if (
              row.isSerialized == 1 ||
              row.serial_number == 1 ||
              (row.main_product && row.main_product.serial_number == 1) ||
              (row.serialize_number && row.serialize_number.length > 0)
            ) {
              this.selected_line_items[index].isSerialized = 1;
            }
            if (this.isDuplicateMode) {
              this.selected_line_items[index].serialNumber = [];
              this.selected_line_items[index].adjust_serial_array = [];
              this.selected_line_items[index].serialize_number = [];
              this.selected_line_items[index].serial_numbers_input = [];
              this.selected_line_items[index].assigned_quantity = 0;
            } else if (
              row.serialize_number &&
              row.serialize_number.length &&
              (!row.serialNumber || !row.serialNumber.length)
            ) {
              const mappedSerials = row.serialize_number.map((x) =>
                typeof x === "object" ? x.serial_number_id || x.id : Number(x)
              );
              this.selected_line_items[index].serialNumber = mappedSerials;
              this.selected_line_items[index].adjust_serial_array =
                mappedSerials;
            }
          });
          (this.show_price = param.show_price == 1 ? true : false),
            (this.adjustment = param.adjustment);
          this.collected_amount = param.collected_amount;
          this.gst_value =
            param.tax_value > 0
              ? param.tax_value
              : this.currentEntityDb.gstvalue;
          this.tax_active = param.tax_applied == 1 ? true : false;
          this.discount_level =
            param.discount_type == 2 ? "line_item" : "transaction";
          if (param && param.discount_value_type) {
            this.discount_value = param.discount_value;
            this.discount_type = this.lodash.toSafeInteger(
              param.discount_value_type
            );
          }

          if (param && param.uom) {
            this.uom = param.uom ?? null;
          }
          this.calculate_total();
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.$store.commit("setLineItemLoading", false);
        });
    },
    remove_row(index, row) {
      if (row.preventive_id > 0 && row.id > 0 && row?.is_consumed > 0) {
        this.$emit("remove:payload", row);
      }

      this.selected_line_items.splice(index, 1);
      this.calculate_total();
      this.emit_values();
      if (this.relatedType == 3) {
        this.generateInvoiceSchedule();
      }
    },
    isGSTAllowed() {
      const app_config = AppConfiguration.get();
      const { entity } = app_config;
      const currentEntity = find(entity, { id: this.entityId });
      this.currentEntityDb = currentEntity;
      this.gst_value = currentEntity.gstvalue > 0 ? currentEntity.gstvalue : 9;

      if (currentEntity) {
        if (currentEntity.gst) {
          if (
            this.isJob ||
            this.isEnquiry ||
            this.isQuotation ||
            this.isPreventive
          ) {
            this.tax_active = true;
            return true;
          } else {
            this.tax_active = false;
          }
        }
      }
      return true;
    },
    openSchedule(id) {
      this.pmId = id;
      this.scheduleDialog = true;
    },

    UomData() {
      this.manageUnitDialog = true;
      this.getOptions();
    },
    initializeLumpSum() {
      console.log("Initializing lump sum...");
      if (!this.isQuotationModule) {
        this.is_lump_sum = false;
        return;
      }

      this.is_lump_sum = this.selected_line_items.some(
        (item) => item.is_lump_sum == 1
      );
    },
    onKeepProductPrices() {
      // Accept the new customer as the baseline even though prices are kept
      this.previousCustomerId = this.vCustomerId || this.pendingNewCustomerId;
      this.pendingNewCustomerId = null;
      this.customerChangeDialog = false;
      this.refreshCustomerLatestQuotedRates();
      ErrorEventBus.$emit("update:info", "Keeping current product prices.");
    },
    onUpdateProductPrices() {
      // Only proceed when there are goods/services and the customer actually changed
      const newCustomerId = this.vCustomerId;
      const oldCustomerId = this.previousCustomerId;

      const hasPricedItems = this.selected_line_items.some(
        (it) =>
          (it.product_type || "").toString().toLowerCase() === "goods" ||
          (it.product_type || "").toString().toLowerCase() === "service"
      );

      if (newCustomerId != oldCustomerId && hasPricedItems) {
        this.selected_line_items.forEach((item) => {
          const productType = (item.product_type || "")
            .toString()
            .toLowerCase();
          if (["goods", "service"].includes(productType)) {
            item.customer_average_quoted_rate = 0;
            item.customer_latest_quoted_rate = 0;
          }
        });

        // get current selected products
        const selectedProductsIds = this.selected_line_items
          .filter(
            (item) =>
              (item.product_type || "").toString().toLowerCase() === "goods"
          )
          .map((item) => Number(item.product_id || item.id || 0))
          .filter((id) => Number.isInteger(id) && id > 0);

        const selectedServiceIds = this.selected_line_items
          .filter(
            (item) =>
              (item.product_type || "").toString().toLowerCase() === "service"
          )
          .map((item) => Number(item.product_id || item.id || 0))
          .filter((id) => Number.isInteger(id) && id > 0);

        if (!selectedProductsIds.length && !selectedServiceIds.length) {
          this.customerChangeDialog = false;
          this.pendingNewCustomerId = null;
          return;
        }

        this.$store
          .dispatch(POST, {
            url: `product/find-line-items/${newCustomerId}`,
            data: {
              product_ids: selectedProductsIds,
              service_ids: selectedServiceIds,
              sales_executive:
                Number(this.salesExecutive) > 0
                  ? Number(this.salesExecutive)
                  : null,
              quotation_id:
                Number(this.$route?.params?.id || 0) > 0
                  ? Number(this.$route.params.id)
                  : null,
            },
          })
          .then(({ data }) => {
            const updatedLineItems = data?.line_items || [];

            if (!updatedLineItems.length) {
              this.calculate_total();
              this.emit_values();
              this.customerChangeDialog = false;
              this.pendingNewCustomerId = null;
              return;
            }

            // Product IDs can overlap between types, so retain the product type
            // when matching the returned customer quote history.
            const updatedMap = {};
            updatedLineItems.forEach((updatedItem) => {
              const key = `${(updatedItem.product_type || "")
                .toString()
                .toLowerCase()}:${Number(updatedItem.product_id)}`;
              updatedMap[key] = updatedItem;
            });

            // Update every matching goods/service line item with all fields from the response
            this.selected_line_items.forEach((item) => {
              const productType = (item.product_type || "")
                .toString()
                .toLowerCase();
              if (!["goods", "service"].includes(productType)) return;
              const key = `${productType}:${Number(item.product_id || 0)}`;
              const updatedItem = updatedMap[key];
              if (!updatedItem) return;

              // Price fields
              item.rate = updatedItem.rate;
              item.selling_cost = updatedItem.selling_cost;
              item.project_price = updatedItem.project_price;
              item.threshold_price = updatedItem.threshold_price;

              // Product identity fields
              item.product = updatedItem.product;
              item.product_id = updatedItem.product_id;
              item.product_type = updatedItem.product_type;
              item.barcode = updatedItem.barcode;

              // Descriptive / meta fields
              item.description = updatedItem.description;
              item.uom = updatedItem.uom;
              item.has_warranty = updatedItem.has_warranty;
              item.customer_average_quoted_rate = Number(
                updatedItem.customer_average_quoted_rate || 0
              );
              item.customer_latest_quoted_rate = Number(
                updatedItem.customer_latest_quoted_rate || 0
              );
            });

            this.calculate_total();
            this.emit_values();
            ErrorEventBus.$emit(
              "update:success",
              "Product prices updated based on new customer."
            );
          })
          .catch((error) => {
            console.error(
              "Error occurred while fetching updated line items:",
              error
            );
            ErrorEventBus.$emit(
              "update:error",
              "Failed to update product prices. Please try again."
            );
          })
          .finally(() => {
            // Update baseline so next customer change is detected correctly
            this.previousCustomerId = this.vCustomerId;
            this.customerChangeDialog = false;
            this.pendingNewCustomerId = null;
          });
      }
    },
    refreshCustomerLatestQuotedRates() {
      if (!this.isQuotationModule) return;
      const customerId = Number(this.vCustomerId || 0);
      const salesId = Number(this.salesExecutive || 0);

      if (!customerId || !salesId) {
        this.selected_line_items.forEach((item) => {
          if (item && item.type !== "header") {
            this.$set(item, "customer_latest_quoted_rate", null);
            this.$set(item, "customer_average_quoted_rate", null);
          }
        });
        return;
      }

      const selectedProductsIds = this.selected_line_items
        .filter(
          (item) =>
            item &&
            (item.product_type || "").toString().toLowerCase() === "goods"
        )
        .map((item) => Number(item.product_id || item.id || 0))
        .filter((id) => Number.isInteger(id) && id > 0);

      const selectedServiceIds = this.selected_line_items
        .filter(
          (item) =>
            item &&
            (item.product_type || "").toString().toLowerCase() === "service"
        )
        .map((item) => Number(item.product_id || item.id || 0))
        .filter((id) => Number.isInteger(id) && id > 0);

      if (!selectedProductsIds.length && !selectedServiceIds.length) {
        return;
      }

      const quotationId = Number(this.$route?.params?.id || 0);

      this.$store
        .dispatch(POST, {
          url: `product/find-line-items/${customerId}`,
          data: {
            product_ids: selectedProductsIds,
            service_ids: selectedServiceIds,
            sales_executive: salesId,
            quotation_id: quotationId,
          },
        })
        .then(({ data }) => {
          const updatedLineItems = data?.line_items || [];
          const updatedMap = {};
          updatedLineItems.forEach((updatedItem) => {
            const key = `${(updatedItem.product_type || "")
              .toString()
              .toLowerCase()}:${Number(updatedItem.product_id)}`;
            updatedMap[key] = updatedItem;
          });

          this.selected_line_items.forEach((item) => {
            const productType = (item.product_type || "")
              .toString()
              .toLowerCase();
            if (!["goods", "service"].includes(productType)) return;
            const key = `${productType}:${Number(item.product_id || 0)}`;
            const updatedItem = updatedMap[key];
            const latestRate =
              updatedItem && Number(updatedItem.customer_latest_quoted_rate) > 0
                ? Number(updatedItem.customer_latest_quoted_rate)
                : null;
            this.$set(item, "customer_latest_quoted_rate", latestRate);
          });
        })
        .catch((err) => {
          console.error("Failed to refresh latest quoted rates:", err);
        });
    },
    openQuotationModal(row, index) {
      if (String(row.po_type).toLowerCase() !== "quotation") {
        return;
      }

      this.selectedRowForQuotation = row;
      this.quotationRowIndex = index;

      if (this.quotationListLoaded) {
        this.quotationDialog = true;
        return;
      }

      this.$store
        .dispatch(QUERY, {
          url: "quotation",
          data: {
            status: "all",
            current_page: 1,
            per_page: 100,
          },
        })
        .then(({ data }) => {
          this.quotationList = Array.isArray(data?.rows) ? data.rows : [];
          this.quotationListLoaded = true;
          this.quotationDialog = true;
        })
        .catch(() => {
          this.quotationList = [];
          this.quotationDialog = true;
        });
    },
    onPoTypeChange(row) {
      if (String(row.po_type).toLowerCase() !== "quotation") {
        this.$set(row, "linked_quotation", null);
        this.$set(row, "quotation_id", null);
        this.clearQuotationAllocations(row);
        this.emit_values();
      }
    },
    clearQuotationAllocations(row) {
      this.$set(row, "allocations", []);
      this.$set(row, "visit_allocations", []);
      this.$set(row, "allocation_summary", "");
    },
    onSelectQuotation(item) {
      if (
        this.quotationRowIndex !== null &&
        this.selected_line_items[this.quotationRowIndex]
      ) {
        const row = this.selected_line_items[this.quotationRowIndex];
        if (Number(row.quotation_id) !== Number(item.id)) {
          this.clearQuotationAllocations(row);
        }
        this.$set(row, "linked_quotation", item.barcode);
        this.$set(row, "quotation_id", item.id);
        this.emit_values();
      }
    },
    openAllocationModal(row, index) {
      const quotationId = Number(row.quotation_id || row.quotation) || null;
      if (quotationId && Number(row.quotation_id) !== quotationId) {
        this.$set(row, "quotation_id", quotationId);
      }
      this.selectedRowForAllocation = row;
      this.allocationRowIndex = index;
      this.allocationDialog = true;
    },
    onSaveAllocation(data) {
      if (
        this.allocationRowIndex !== null &&
        this.selected_line_items[this.allocationRowIndex]
      ) {
        this.$set(
          this.selected_line_items[this.allocationRowIndex],
          "allocation_summary",
          data.summary
        );
        this.$set(
          this.selected_line_items[this.allocationRowIndex],
          "allocations",
          data.allocations
        );
        this.emit_values();
      }
    },
  },
  components: {
    ManageUnit,
    Draggable,
    LineItemDialog,
    AddressSelect,
    ManageWarranty,
    PMSchedule,
    SerialNumber,
    Dialog,
    SelectAcceptedQuotationModal,
    AllocateQuantityModal,
  },
  mounted() {
    this.do_update = this.lodash.toSafeInteger(this.$route.query.do_update);
    this.getOptions();
    this.isGSTAllowed();
    this.initializeLumpSum();
  },
  beforeMount() {
    this.pmData = this.$route?.query?.pmSchedule;
  },
  created() {
    const relatedId = Number(this.$route?.query?.edit ?? 0);
    if (relatedId > 0) {
      this.$store.commit(UPDATE_SCHEDULE_STATE, {
        key: "isEdit",
        value: true,
      });
      this.$store.commit(UPDATE_SCHEDULE_LIST_QUOTE, {
        key: "dbScheduleOutput",
        value: this.dbInvoiceUpdateSchedule,
      });
    }
  },
  computed: {
    ...mapGetters([
      "vCustomerId",
      "vStateLoading",
      "vLineItem",
      "vSelectedLineItem",
      "vLineItemAlpha",
      "vLineItemCategory",
      "vLineItemUnit",
      "rawScheduleOutput",
      "recurringinvoice",
      "invoiceScheduleOutput",
      "invoiceRecurringSchedule",
      "quoteInvoiceParameters",
      "dbInvoiceUpdateSchedule",
      "isEdit",
    ]),

    isQuotationModule() {
      return this.$route.path.includes("quotation");
    },
    isDuplicateMode() {
      return Boolean(this.isDuplicate || this.$route?.query?.duplicate);
    },
    modulesTypeComputed() {
      if (this.isPurchaseOrder) {
        return [
          {
            value: "goods",
            text: "Product",
            show: true,
          },
          {
            value: "parts",
            text: "Part",
            show: true,
          },
        ];
      }
      return this.modulesType;
    },
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
